import React from "react";
import { Navigate } from "react-router-dom";
import { useRoles } from "../security/RolesProvider/RolesProvider";
import {
	getAccessibleModulePermissions,
	isAccessibleModule,
} from "../security/isModuleAccess";

import { PremissionsProvider } from "../security/PremissionsProvider/PremissionsProvider";

interface IAuthorizedRouteProps {
	moduleIds: string[];
	allowFullAccess?: boolean;
	children: React.ReactNode;
}

export const AuthorizedRoute: React.FC<IAuthorizedRouteProps> = (props) => {
	const { moduleIds, allowFullAccess } = props;
	const { roles } = useRoles();

	if (isAccessibleModule(moduleIds, roles, allowFullAccess)) {
		const permissions = getAccessibleModulePermissions(
			moduleIds,
			roles,
			allowFullAccess
		);

		return (
			<PremissionsProvider premissions={permissions}>
				{props.children}
			</PremissionsProvider>
		);
	}

	return <Navigate to="/access" />;
};
